import {BulkPrintDocumentKey} from '@dms/api/workshop';

export interface GenerationResult {
  key: BulkPrintDocumentKey;
  url: string;
  fileId: string;
}

export function getSingleGeneratedDocument(
  generationResults: Record<string, GenerationResult>,
  generationFailures: Record<string, string>
) {
  const generatedResults = Object.values(generationResults);

  if (generatedResults.length !== 1 || Object.keys(generationFailures).length > 0) {
    return undefined;
  }

  return generatedResults[0];
}
